import { useFormContext } from "react-hook-form";

import type { CompletionFormValues } from "./types";

export const useCompletionFormContext = () => useFormContext<CompletionFormValues>();
